import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import Routes from "./routes";
import "./index.css";

Sentry.init({
  dsn: "https://ae3a9e18bb41c9675c4cd0183bb4dbfe@o4507737019252736.ingest.de.sentry.io/4509339499233360",
  sendDefaultPii: true,
  environment: import.meta.env.MODE,
  enabled: true,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
});

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={<div style={{ padding: 20 }}>
        <h1 className="font-bold text-lg">Erro inesperado na página</h1>
        <p className="text-zinc-500 text-sm">Fomos notificados e iremos analisar o erro. Retorne em breve.</p>
      </div>}
    >
      <Routes />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
